import React from 'react'
import { withRouter } from 'react-router-dom'
import AppBar from '../../components/AppBar'
import {
  getUserTimezone,
  getBrowserTimezone,
  saveUserTimezone,
  getUTCOffset,
  getCityName,
  COMMON_TIMEZONES,
} from '../../utils/timezoneStorage'

class TimezoneSettingsScene extends React.Component {
  state = {
    selectedTimezone: getUserTimezone(),
    browserTimezone: getBrowserTimezone(),
    showReloadMessage: false,
  }

  handleTimezoneChange = (event) => {
    const newTimezone = event.target.value

    // Update state
    this.setState({ selectedTimezone: newTimezone, showReloadMessage: true })

    // Auto-save to localStorage
    saveUserTimezone(newTimezone)

    // Reload page after a short delay to apply the new timezone
    setTimeout(() => {
      window.location.reload()
    }, 1500)
  }

  handleBack = () => {
    this.props.history.push('/menu')
  }

  render() {
    const { selectedTimezone, browserTimezone, showReloadMessage } = this.state
    const browserCityName = getCityName(browserTimezone)
    const browserOffset = getUTCOffset(browserTimezone)

    return (
      <div>
        <AppBar header="TIMEZONE SETTINGS" />

        <div className="p-5 max-w-3xl mx-auto">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
            <div className="border-b border-gray-200 px-6 py-4">
              <h3 className="text-2xl font-bold text-gray-900">
                Timezone Settings
              </h3>
            </div>
            <div className="p-6">
              <p className="mb-5 text-gray-600">
                Select your timezone for displaying dates and times throughout
                the application. Changes are saved automatically.
              </p>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Display Timezone
                </label>
                <select
                  value={selectedTimezone}
                  onChange={this.handleTimezoneChange}
                  className="w-full px-4 py-3 text-base text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
                >
                  <option value={browserTimezone}>
                    Browser Default - {browserCityName} ({browserOffset})
                  </option>
                  <option disabled>──────────</option>
                  {COMMON_TIMEZONES.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                      {tz.label}
                    </option>
                  ))}
                </select>
                <p className="mt-1.5 text-xs text-gray-500">
                  Browser default: {browserCityName} ({browserOffset})
                </p>
              </div>

              {showReloadMessage && (
                <div className="mt-5 bg-green-50 border border-green-200 rounded-lg p-4">
                  <p className="text-green-800">
                    <strong>Saved!</strong> Reloading page to apply timezone
                    changes...
                  </p>
                </div>
              )}

              <div className="mt-8">
                <button
                  onClick={this.handleBack}
                  className="px-8 py-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(TimezoneSettingsScene)
